function minutesAgo(mins: number): string {
  return new Date(Date.now() - mins * 60 * 1000).toISOString();
}

function randomInt(): number {
  return Math.floor(Math.random() * (45 - 1 + 1)) + 1;
}

export const notifications = {
  cartNotifications: [
    {
      guid: '86753092',
      name: '5N HQ BA - # 350',
      locationName: 'Manhattan - Building A',
      timeStamp: minutesAgo(randomInt()),
      errorCode: 2001,
      notification: '360 camera is not available.',
      cartId: 2017,
      id: 82,
    },
    {
      guid: '86753092',
      name: '2N HQ BA - # 964',
      locationName: 'Manhattan - Building B',
      timeStamp: minutesAgo(randomInt()),
      errorCode: 1001,
      notification: 'Scanner is not available.',
      cartId: 7703,
      id: 81,
    },
    {
      guid: '86753092',
      name: '2N HQ BA - # 424',
      locationName: 'Manhattan - Building C',
      timeStamp: minutesAgo(randomInt()),
      errorCode: 2001,
      notification: '360 camera is not available.',
      cartId: 1140,
      id: 80,
    },
    {
      guid: '86753092',
      name: '5S HQ BA - # 593',
      locationName: 'Brooklyn - Building A',
      timeStamp: minutesAgo(randomInt()),
      errorCode: 1001,
      notification: 'Scanner is not available.',
      cartId: 8618,
      id: 79,
    },
    {
      guid: '86753092',
      name: '5N HQ BA - # 894',
      locationName: 'Brooklyn - Building B',
      timeStamp: minutesAgo(randomInt()),
      errorCode: 2001,
      notification: '360 camera is not available.',
      cartId: 2876,
      id: 78,
    },
    {
      guid: '86753092',
      name: '9N HQ BA - # 951',
      locationName: 'Brooklyn - Building C',
      timeStamp: minutesAgo(randomInt()),
      errorCode: 1001,
      notification: 'Scanner is not available.',
      cartId: 2162,
      id: 77,
    },
    {
      guid: '86753092',
      name: '4N HQ BA - # 940',
      locationName: 'Bronx - Building A',
      timeStamp: minutesAgo(randomInt()),
      errorCode: 2001,
      notification: '360 camera is not available.',
      cartId: 1013,
      id: 76,
    },
    {
      guid: '86753092',
      name: '5N HQ BA - # 151',
      locationName: 'Bronx - Building B',
      timeStamp: minutesAgo(randomInt()),
      errorCode: 1001,
      notification: 'Scanner is not available.',
      cartId: 4856,
      id: 75,
    },
    {
      guid: '86753092',
      name: '5S HQ BA - # 764',
      locationName: 'Bronx - Building C',
      timeStamp: minutesAgo(randomInt()),
      errorCode: 2001,
      notification: '360 camera is not available.',
      cartId: 2898,
      id: 74,
    },
  ],
};
